function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React from "react";
export default class extends React.Component {
  constructor(props) {
    super(props);
    _defineProperty(this, "calculate", () => {
      var show = true;
      var noChange = false;
      var up = false;
      var data = this.props.data;
      var compare = this.props.compare;
      if (!compare) {
        show = false;
      }
      if (data === compare) {
        noChange = true;
      }

      //Trend Percentage = ((Current Period Value - Base Period Value) / Base Period Value) * 100
      var percentage = (data - compare) / compare * 100;
      if (!Number.isInteger(percentage)) {
        percentage = percentage.toFixed(1);
      }
      up = percentage > 0;
      percentage = percentage.toString() + '%';
      return {
        percentage: percentage,
        up: up,
        show: show,
        noChange: noChange
      };
    });
  }
  render() {
    var calculate = this.calculate();
    if (!calculate.show) {
      return null;
    }
    if (calculate.noChange) {
      return /*#__PURE__*/React.createElement("div", {
        className: "trend-container no-change"
      }, "---");
    }
    if (calculate.up) {
      return /*#__PURE__*/React.createElement("div", {
        className: "trend-container up"
      }, /*#__PURE__*/React.createElement("span", {
        className: "material-icons"
      }, "north"), calculate.percentage);
    } else return /*#__PURE__*/React.createElement("div", {
      className: "trend-container"
    }, /*#__PURE__*/React.createElement("span", {
      className: "material-icons"
    }, "south"), calculate.percentage);
  }
}